(function(){
  angular.module('edxComponents')
    .directive("domainsList", function() {
      return {
        restrict: "E",
        scope: {
        },
        transclude: true,
        templateUrl: '/resources/components/assign-focus/domains-list.directive.html',
        controller: [
          '$state',
          '$scope',
          '$element',
          '$filter',
          '$timeout',
          'standard',
          'edxCreateAstAssignmentConfigurationService',
          DomainsListController]
      };
    });

  function DomainsListController (
    $state,
    $scope,
    $element,
    $filter,
    $timeout,
    $standard,
    edxCreateAstAssignmentConfigurationService
  ) {
    var domainSelectName =  "Select a Domain";
    var domainSearchName =  "Search for a domain...";
    var defaultDomain = { name: domainSelectName, percent_complete: -1};
    $scope.domainSearchName = domainSearchName;
    $scope.domains = { list: [], selected: defaultDomain };

    $scope.showPercents = false;

    function handleAstChange(astName) {
      $scope.astName = astName;
      defaultDomain.name = $filter('domainText')(domainSearchName, astName);
    }

    $scope.$on('astChanged', function(e, data) {
      handleAstChange(data.astName);
    });

    $scope.$on('domainsLoaded', function(e, data) {
      $standard.updateSelectedDomain(data.domains);
      $scope.domains.list = angular.copy(data.domains);

      handleAstChange(data.astName);

      var params = $standard.getParams();
      if ($scope.shouldSuppressDomainsList()) {
        $scope.domains.selected = $scope.domains.list[0];
        var domainCode = $scope.domains.selected ? $scope.domains.selected.code : '';
        $standard.resetQueryParams({ grade: params.grade, domain: domainCode });
      } else {
        $scope.domains.selected = _.findWhere($scope.domains.list, {code: String(params.domain)}) || defaultDomain;
      }

      $timeout(function() {
        $scope.$emit('loadStandards');
      });

    });

    $scope.domainClicked = function(domain) {
      $scope.domains.selected = domain;
      var params = $standard.getParams();
      $standard.resetQueryParams({ grade: params.grade, domain: domain.code });

      $timeout(function() {
        $scope.$emit('loadStandards');
      });
    };

    $scope.shouldSuppressDomainsList = function shouldSuppressDomainsList() {
      return $scope.domains.list.length <= 1 &&
        edxCreateAstAssignmentConfigurationService[$scope.astName] &&
        edxCreateAstAssignmentConfigurationService[$scope.astName].hideDomainsList;
    };
  }
})();
